import { z } from "zod";

export const filtersFormSchema = z.object({
    accounts: z.union([z.string(), z.array(z.string())]).optional(),
    action: z.string().optional(),
    amountFrom: z.string().nullable().optional(),
    amountTo: z.string().nullable().optional(),
    category: z.string().optional(),
    confidenceFrom: z.string().nullable().optional(),
    confidenceTo: z.string().nullable().optional(),
    connectionType: z.string().optional(),
    currency: z.string().optional(),
    dataSources: z.union([z.string(), z.array(z.string())]).optional(),
    date: z.object({
        from: z.date().nullable().optional(),
        to: z.date().nullable().optional(),
    }).optional(),
    organization: z.string().optional(),
    rule: z.string().optional(),
    settlementDelay: z.object({
        from: z.date().nullable().optional(),
        to: z.date().nullable().optional(),
    }).optional(),
    status: z.union([z.string(), z.array(z.string())]).optional(),
    subscriptionPlan: z.string().optional(),
    type: z.union([z.string(), z.array(z.string())]).optional(),
    windowSize: z.string().optional(),
});
